import React, {Fragment} from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import LazyCheckbox from 'js/reusable/shared-components/components/lazyCheckbox';
import {__} from 'js/tool/page/current';

type IProps = {
	policy: boolean;
	togglePolicy: () => void
}

function LoginPolicy({policy, togglePolicy}: IProps) {
	return (
		<Form.Row>
			<Col>
				<LazyCheckbox
					text={
						<Fragment>
							{__('fb:first time logging in agree')}
							&nbsp;
							<a
								href="https://www.alephholding.com/privacy-policy"
								target="_blank"
							>
								{__('entrance: privacy policy')}
							</a>.
						</Fragment>
					}
					isChecked={policy}
					onChange={togglePolicy}
				/>
			</Col>
		</Form.Row>
	);
}

export default LoginPolicy;
